import api from '@/api'

export default {
    /**
     * 전자결재 카운팅 웹파트 데이터 조회
     */
    getWorkflowCounts(): Promise<workflow.WorkflowWebpartSetting>{
        return api.get<workflow.WorkflowWebpartSetting>({
            url: '/yek/home/api/workflow/count',
        })
    },

    /**
     * 부서원 일정 조회
     */
    getDeptUserSchedules(): Promise<calendar.UserSchedule[]> {
        return api.get({
            url: '/yek/home/api/deptuser/schedules'
        });
    }
}
